module.exports = __webpack_public_path__ + "static/media/my_img.4a526ad5.jpg";